import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, formatDateToShortDot, useT } from '@repo/common';

import PreviewLargerModal from '../../Career/Preview/PreviewLargerModal';

const ResumeRow = ({ resume, status, isMyPage, $isMobile }) => {
  const t = useT();
  const navigate = useNavigate();
  const [showViewModal, setShowViewModal] = useState(false);

  if (!resume) return null;

  const resumeScore =
    resume.score === 100 ? t('Ready', '완성') : t('Draft', '작성 중');

  return (
    <div
      className={`flex w-full bg-grayscale-gray00 rounded-lg ${
        (isMyPage && status === 'view') || $isMobile
          ? 'border-grayscale-gray02'
          : 'border-grayscale-gray03'
      } border items-center ${status === 'edit' && 'flex-col'}`}
    >
      <div
        className={`flex ${
          $isMobile
            ? 'p-4'
            : isMyPage || status === 'view'
              ? 'p-6'
              : 'py-4 px-6'
        } justify-center items-center w-full`}
      >
        <div className='flex flex-col w-full pr-2 gap-2 tabletH:gap-0 tabletH:p-0'>
          <div className='flex flex-col tabletH:flex-row pb-0 tabletH:pb-1 items-start tabletH:items-center text-center gap-2 w-full'>
            {resume.standard && (
              <div className='px-2 py-[1px] tabletH:px-[6px] tabletH:py-[2px] rounded-md bg-purple-purple01 text-text-accent typo-b11 tabletH:typo-b12Strong'>
                {t('Standard', '기본')}
              </div>
            )}
            {!$isMobile && (
              <div className='typo-b16Strong text-text-primary'>
                {resume.title}
              </div>
            )}
          </div>

          <div className='flex flex-col gap-1'>
            {$isMobile && (
              <div className='typo-b13 text-text-primary'>{resume.title}</div>
            )}
            <div className='flex items-center gap-1.5 text-text-secondary typo-b12 tabletH:ypo-b13'>
              <div>{formatDateToShortDot(resume.modifiedAt)}</div>
              <div className='w-[1px] self-stretch bg-grayscale-gray02' />
              <div>
                {resumeScore} {resume.score}% {t('complete', '완료')}
              </div>
            </div>
          </div>
        </div>

        {status === 'view' && (
          <>
            <BaseButton type='text' size='s' hideIcon onClick={() => setShowViewModal(true)}>
              {t('View submitted resume', '제출 이력서 보기')}
            </BaseButton>
            {showViewModal && (
              <PreviewLargerModal resumeData={resume} onClose={() => setShowViewModal(false)} isApply />
            )}
          </>
        )}
      </div>

      {status === 'edit' && (
        <div className='border-t border-grayscale-gray03 w-full'>
          <div className='flex w-full text-text-secondary typo-b14'>
            <BaseButton
              type='text'
              size='s'
              hideIcon
              typo={false}
              isStatic
              className='h-auto w-full min-w-0 cursor-pointer rounded-none border-0 border-r border-grayscale-gray03 bg-transparent p-2 text-inherit'
              textWrapperClass='h-auto'
              onClick={() => navigate(`/career/resumes/${resume?.id}`)}
            >
              {t('Edit', '수정')}
            </BaseButton>
            <BaseButton
              type='text'
              size='s'
              hideIcon
              typo={false}
              isStatic
              className='h-auto w-full min-w-0 cursor-pointer rounded-none border-0 bg-transparent p-2 text-inherit'
              textWrapperClass='h-auto'
              onClick={() => setShowViewModal(true)}
            >
              {t('View', '보기')}
            </BaseButton>
            {showViewModal && (
              <PreviewLargerModal
                resumeData={resume}
                onClose={() => setShowViewModal(false)}
                isApply
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResumeRow;
